import React from 'react';
import Icon from '@ramsey-design-system/icon';

import '@ramsey-design-system/icon/dist/icon.css';
const RDSIcon = (props: React.ComponentProps<typeof Icon>) => {
  return <Icon {...props} />;
};

export default RDSIcon;
